// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import Request from './request';

async function fetch(data) {
    return Request('get', "api/material-sales", data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/material-sales/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function exportsJX(data) {// 导出报表江西
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/material-sales/jiangXiExport", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/material-sales/" + id, data);
}

async function exportOne(id, data) {// 导出单个的报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/material-sales/export-detail/" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getMaterialDailySaleCount(data) {
    return Request('get', "api/material-sales/material-daily-sale-count", data);
}

async function materialDailySaleCountExport(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/material-sales/material-daily-sale-count-export", data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch, exports,
    fetchOne, exportOne,
    exportsJX,
    getMaterialDailySaleCount,
    materialDailySaleCountExport,
};